export default __webpack_public_path__ + "5c506ce5c0dfd82588f66089ecff0792.svg";